import React, { Component } from 'react';
import { Utils } from 'common';
import MapContactFieldsUtil from '../utils/MapContactFieldsUtil';
import MapContactFieldsRightPanel from './MapContactFieldsRightPanel.component';

const { Session } = Utils;

class MapContactFields extends Component {
	constructor(props) {
		super(props);
		const { mappedData } = props;

		this.state = {
			...mappedData,
			isResetAllTriggered: true,
		};
	}

	// to re-map all the column when the row changes
	onRowChanged = (selectedRow, currentStampsColumnOptions) => {
		const { mapContactsCallback, importedContactsRows } = this.props;
		const mappedData = MapContactFieldsUtil.buildMappedData(
			importedContactsRows,
			selectedRow,
			this.state
		);

		this.setState({ ...mappedData, stampsColumnOptions: currentStampsColumnOptions });
		mapContactsCallback({
			isMapped: mappedData.noOfMappedColumns > 0,
			newSdcMappedContactFields: mappedData.sdcColumnMapping,
		});
	};

	// to reset all column mappings
	resetAllMappings = () => {
		const { columnsMappedData, isResetAllTriggered } = this.state;
		const { mapContactsCallback } = this.props;
		const newColumnsMappedData = columnsMappedData.map(mappedData => {
			mappedData.option = { id: '-1', enabled: true };
			mappedData.isMapped = false;
			return mappedData;
		});

		this.setState({
			columnsMappedData: newColumnsMappedData,
			sdcColumnMapping: {},
			isResetAllTriggered: !isResetAllTriggered,
		});
		mapContactsCallback({ isMapped: false });
	};

	render() {
		const {
			columnsMappedData,
			disabledColumnsData,
			stampsColumnOptions,
			isAllColumnMapped,
			isNoColumnMapped,
			isFewColumnMapped,
			sdcColumnMapping,
			isResetAllTriggered,
		} = this.state;
		const {
			isTemplateMapped,
			mapContactsCallback,
			onIsRowOneHeaderChanged,
			importedContactsRows,
		} = this.props;
		const { brandName } = Session.getBrand();

		return (
			<div className="map-contacts-fields">
				<div className="left-panel">
					<div className="primary-header">
						{!isAllColumnMapped ? 'Map Your Columns to Ours' : 'Review Column Mapping'}
					</div>
					{isNoColumnMapped ? (
						<div className="map-contacts-text">
							<p>
								To create a mapping, select a {brandName} column from the dropdown
								that closely matches with yours.
							</p>
							<p>Repeat until all of your desired columns are mapped to ours.</p>
							<p>
								To undo a mapping, click the X icon next to a mapping or{' '}
								<a
									className="details"
									role="button"
									tabIndex={0}
									onClick={() => {
										this.resetAllMappings();
									}}
								>
									Reset All Mappings
								</a>
								.
							</p>
						</div>
					) : (
						''
					)}
					{!isNoColumnMapped && isFewColumnMapped ? (
						<div className="map-contacts-text">
							<p>We've helped you map some of your fields.</p>
							<p>
								To finish your mapping, select a {brandName} column from the
								dropdown that closely matches with yours.
							</p>
							<p>Repeat until all of your desired columns are mapped to ours.</p>
							<p>
								To undo a mapping, click the X icon next to a mapping or{' '}
								<a
									className="details"
									role="button"
									tabIndex={0}
									onClick={() => {
										this.resetAllMappings();
									}}
								>
									Reset All Mappings
								</a>
								.
							</p>
						</div>
					) : (
						''
					)}
					{isAllColumnMapped ? (
						<div className="map-contacts-text">
							<p>
								We've automatically mapped the columns in your file to ours. Please
								review this mapping for accuracy.
							</p>
							<p>
								If you want to undo any mapping, click the X icon next to a mapping
								or{' '}
								<a
									className="details"
									role="button"
									tabIndex={0}
									onClick={() => {
										this.resetAllMappings();
									}}
								>
									Reset All Mappings
								</a>
								.
							</p>
							<p>
								To create a mapping, select a {brandName} column from the dropdown
								that closely matches with yours.
							</p>
							<p>Repeat until all of your desired columns are mapped to ours.</p>
						</div>
					) : (
						''
					)}
				</div>
				<MapContactFieldsRightPanel
					columnsMappedData={columnsMappedData}
					disabledColumnsData={disabledColumnsData}
					stampsColumnOptions={stampsColumnOptions}
					sdcColumnMapping={sdcColumnMapping}
					onRowChanged={this.onRowChanged}
					rows={importedContactsRows.length}
					brandName={brandName}
					onIsRowOneHeaderChanged={onIsRowOneHeaderChanged}
					isTemplateMapped={isTemplateMapped}
					mapContactsCallback={mapContactsCallback}
					isResetAllTriggered={isResetAllTriggered}
				/>
			</div>
		);
	}
}

export default MapContactFields;
